import React from 'react';

import PropTypes from 'prop-types';

/* Components */
import Avatar from '../../common/avatar/avatar';
import IconButton from '../../common/icon-button/icon-button';
import Checkbox from '../../common/form-elements/checkbox/checkbox';
import Tooltip from 'rc-tooltip';
import TextOverflowTooltip from '../../common/TextOverflowTooltip';
import OnboardingTooltipContainer from '../../onboarding/OnboardingTooltipContainer';

/* Helpers */
import {
  isAuthorizedAction,
  isDashboardCreatedInCurrentOrganization,
} from '../../../helpers/dashboard-helpers';
import {isCurrentUser} from '../../../helpers/user-helpers';

import {connect} from 'react-redux';
import {DASHBOARD_EDIT_PAGE_LABEL, HEADER_SECTION} from '../../onboarding/constants';

const Steve = require('@gluenetworks/steve_core').getInstance();

const fullScreenEvents = [
  'webkitfullscreenchange',
  'mozfullscreenchange',
  'fullscreenchange',
  'MSFullscreenChange',
];

class DashboardHeader extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isFullscreen: false,
      isDashboardCreatedInCurrentOrganization: isDashboardCreatedInCurrentOrganization(
        this.props.currentDashboard.tenantId
      ),
    };
  }

  fullScreenElement = document.getElementById('gluware-react-app');

  componentDidMount() {
    if (this.fullScreenElement) {
      fullScreenEvents.forEach((fullScreenEvent) => {
        this.fsListener = this.fullScreenElement.addEventListener(
          fullScreenEvent,
          this.fullscreenChanged
        );
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedOrganization !== prevProps.selectedOrganization) {
      this.setDashboardCreated();
    }
  }

  setDashboardCreated() {
    this.setState({
      isDashboardCreatedInCurrentOrganization: isDashboardCreatedInCurrentOrganization(
        this.props.currentDashboard.tenantId
      ),
    });
  }

  fullscreenChanged = () => {
    const willEnterFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;
    if (!willEnterFullscreen) {
      this.togglePolling(true);
      this.fullScreenElement.classList.remove('gluware-react-app--fullscreen');
    } else {
      this.togglePolling(false);
    }
    this.setState({
      isFullscreen: willEnterFullscreen,
    });
  };

  goToLibrary = () => {
    this.togglePolling(true);
    this.exitFullScreen();
    this.props.history.push('/dashboard/library');
  };

  goToEdit = () => {
    this.props.history.push(`/dashboard/edit/${this.props.id}`);
  };

  goBack = () => {
    this.props.history.goBack();
  };

  toggleFullScreen = () => {
    if (this.fullScreenElement) {
      const isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;
      this.fullScreenElement.requestFullScreen =
        this.fullScreenElement.requestFullScreen ||
        this.fullScreenElement.webkitRequestFullScreen ||
        this.fullScreenElement.mozRequestFullScreen ||
        false;
      document.cancelFullScreen =
        document.cancelFullScreen ||
        document.webkitCancelFullScreen ||
        document.mozCancelFullScreen ||
        false;
      if (isFullscreen) {
        this.togglePolling(true);
        document.cancelFullScreen();
        this.fullScreenElement.classList.remove('gluware-react-app--fullscreen');
        this.setState({
          isFullscreen: false,
        });
      } else {
        this.togglePolling(false);
        this.fullScreenElement.requestFullScreen();
        this.fullScreenElement.classList.add('gluware-react-app--fullscreen');
        this.setState({
          isFullscreen: true,
        });
      }
    }
  };

  togglePolling = (state = false) => {
    if (Steve.userSession.user.getActionGroupId() === '68a298fa-f4ca-4c6a-886c-a096fc9251fc') {
      Steve.activityMonitor.togglePolling(state);
    }
  };

  componentWillUnmount() {
    fullScreenEvents.forEach((fullScreenEvent) => {
      window.removeEventListener(fullScreenEvent, this.fsListener);
    });
  }

  handlePublish = () => {
    this.exitFullScreen();
    this.props.onPublish();
  };

  handlePauseRotation = () => {
    this.props.togglePauseRotation();
  };

  exitFullScreen() {
    const isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;
    if (isFullscreen) {
      document.cancelFullScreen =
        document.cancelFullScreen ||
        document.webkitCancelFullScreen ||
        document.mozCancelFullScreen ||
        false;
      document.cancelFullScreen();
    }
  }

  render() {
    let avatar = null;
    if (this.props.image) {
      avatar = <Avatar imageSrc={this.props.image} />;
    } else if (this.props.isEditAllowed && !this.props.image) {
      avatar = <Avatar isEmpty />;
    }
    return (
      <>
        <div
          className={`glu-page__header
                    ${this.props.isMobileMenuShown && 'glu-page__header--no-shadow'}
                    glu-flex-row`}
        >
          {this.props.isEditAllowed && (
            <OnboardingTooltipContainer page={DASHBOARD_EDIT_PAGE_LABEL} section={HEADER_SECTION} />
          )}
          <div
            className={`glu-flex-grow ${
              this.props.isEditAllowed && 'glu-dashboard-name--max-width'
            }`}
          >
            <div className="glu-row glu-flex glu-flex-row glu-flex-align-center">
              {avatar && !this.props.isMobileDevice && (
                <div
                  className="glu-flex-shrink"
                  onClick={
                    this.props.isEditAllowed
                      ? this.props.setActiveSettingsModalType('imageSettings')
                      : undefined
                  }
                >
                  {avatar}
                </div>
              )}
              <div className="glu-flex-grow">
                <div className="glu-page__title glu-flex-row glu-flex-align-center">
                  <TextOverflowTooltip
                    title={this.props.title}
                    renderChildren={(ref) => (
                      <div className="dashboard-title glu-flex-shrink" ref={ref}>
                        {this.props.title}
                      </div>
                    )}
                  />
                  {this.props.isEditAllowed && (
                    <div className="glu-flex-shrink">
                      <IconButton
                        onClick={this.props.setActiveSettingsModalType('infoSettings')}
                        icon="edit"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {this.props.isEditAllowed ? (
            <>
              <div
                className="glu-flex-shrink glu-flex-shrink--large-padding"
                tooltip-id="addWidget"
              >
                <IconButton
                  onClick={this.props.toggleWidgetsSidebar}
                  icon="dashboard-add"
                  text="Add widget"
                  className={this.props.isWidgetsSidebarShown ? 'active' : ''}
                />
              </div>
              <div
                className="glu-flex-shrink glu-flex-shrink--large-padding "
                tooltip-id="setAsFavorite"
              >
                <IconButton text="Set as favorite">
                  <Checkbox
                    onChange={this.props.toggleDashboardFavorite}
                    isChecked={this.props.isFavorite}
                  >
                    Set as favorite
                  </Checkbox>
                </IconButton>
              </div>
              <div
                className="glu-flex-shrink glu-flex-shrink--large-padding"
                tooltip-id="permissionSettings"
              >
                <IconButton
                  onClick={this.props.setActiveSettingsModalType('permissionSettings')}
                  icon="share"
                  text="Permission settings"
                />
              </div>
              <div
                className="glu-flex-shrink glu-flex-shrink--large-padding"
                tooltip-id="resetConfiguration"
              >
                <IconButton
                  onClick={this.props.setActiveSettingsModalType('resetConfiguration')}
                  icon="reset"
                  text="Reset configuration"
                />
              </div>
              <div className="glu-flex-shrink">
                <button className="glu-btn glu-btn--secondary" onClick={this.goBack}>
                  Cancel
                </button>
              </div>
              <div className="glu-flex-shrink">
                <button
                  disabled={this.props.isPublishDisabled || this.props.publishingDashboard}
                  className="glu-btn glu-btn--primary"
                  onClick={this.handlePublish}
                >
                  Publish
                </button>
              </div>
            </>
          ) : (
            <>
              {this.props.isFavorite && !!this.props.dashboardRotation && (
                <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                  <Tooltip
                    placement="top"
                    trigger={['hover']}
                    overlay={
                      <span>
                        {!this.props.rotationPaused
                          ? 'Pause rotation'
                          : 'Rotate favorite dashboards'}
                      </span>
                    }
                  >
                    <button className="glu-btn-link glu-tooltip">
                      <IconButton
                        onClick={this.props.togglePauseRotation}
                        icon={!this.props.rotationPaused ? 'pause' : 'play'}
                      />
                    </button>
                  </Tooltip>
                </div>
              )}
              {!this.props.isMobileDevice && (
                <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                  <Tooltip placement="top" trigger={['hover']} overlay={<span>Full screen</span>}>
                    <button className="glu-btn-link glu-tooltip">
                      <IconButton
                        onClick={this.toggleFullScreen}
                        icon="full_screen"
                        className={this.state.isFullscreen ? 'active' : ''}
                      />
                    </button>
                  </Tooltip>
                </div>
              )}
              {isAuthorizedAction('privateDashboardWrite') &&
                this.props.currentDashboard &&
                !this.props.isMobileDevice &&
                isCurrentUser(this.props.currentDashboard.ownerId) &&
                this.state.isDashboardCreatedInCurrentOrganization && (
                  <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                    <Tooltip placement="top" trigger={['hover']} overlay={<span>Configure</span>}>
                      <button className="glu-btn-link">
                        <IconButton onClick={this.goToEdit} icon="config" />
                      </button>
                    </Tooltip>
                  </div>
                )}
              {!this.props.isMobileDevice && (
                <>
                  <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                    <Tooltip placement="top" trigger={['hover']} overlay={<span>View info</span>}>
                      <button className="glu-btn-link">
                        <IconButton
                          onClick={this.props.handleDashboardInfoClick(this.props.dashboard)}
                          icon="info"
                          className={this.props.dashboardInfoViewOpen ? 'active' : ''}
                        />
                      </button>
                    </Tooltip>
                  </div>
                  <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                    <Tooltip
                      placement="topRight"
                      trigger={['hover']}
                      overlay={<span>Dashboard library</span>}
                    >
                      <button className="glu-btn-link">
                        <IconButton onClick={this.goToLibrary} icon="library" />
                      </button>
                    </Tooltip>
                  </div>
                </>
              )}
              {this.props.isMobileDevice && (
                <div className="glu-flex-shrink glu-flex-shrink--large-padding">
                  <button className="glu-btn-link">
                    <IconButton
                      onClick={this.props.handleShowMobileMenu}
                      icon={this.props.isMobileMenuShown ? 'close' : 'hamburger'}
                    />
                  </button>
                </div>
              )}
            </>
          )}
        </div>
        {this.props.isMobileDevice && this.props.isMobileMenuShown && (
          <div className="glu-page__mobile-menu">
            <div className="mobile-menu__item">
              <IconButton
                onClick={this.props.handleDashboardInfoClick(this.props.dashboard)}
                icon="info"
                className={this.props.dashboardInfoViewOpen ? 'active' : ''}
                text="Info"
              />
            </div>
            <div className="mobile-menu__item">
              <IconButton onClick={this.goToLibrary} icon="library" text="Dashboard library" />
            </div>
          </div>
        )}
      </>
    );
  }
}

DashboardHeader.propTypes = {
  isEditAllowed: PropTypes.bool.isRequired,
  isPublishDisabled: PropTypes.bool,
  id: PropTypes.string,
  isFavorite: PropTypes.bool,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  onPublish: PropTypes.func.isRequired,
  setActiveSettingsModalType: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  toggleWidgetsSidebar: PropTypes.func.isRequired,
  resetConfiguration: PropTypes.func.isRequired,
  toggleDashboardFavorite: PropTypes.func.isRequired,
  image: PropTypes.string,
  currentDashboard: PropTypes.objectOf(PropTypes.any),
  handleDashboardInfoClick: PropTypes.func.isRequired,
  dashboard: PropTypes.objectOf(PropTypes.any),
  isWidgetsSidebarShown: PropTypes.bool,
  dashboardInfoViewOpen: PropTypes.bool,
  publishingDashboard: PropTypes.bool,
  selectedOrganization: PropTypes.objectOf(PropTypes.any),
  togglePauseRotation: PropTypes.func.isRequired,
  handleShowMobileMenu: PropTypes.func.isRequired,
  isMobileMenuShown: PropTypes.bool.isRequired,
};

DashboardHeader.defaultProps = {
  id: null,
  isPublishDisabled: false,
  image: '',
  isFavorite: false,
  currentDashboard: null,
  dashboard: null,
  isWidgetsSidebarShown: false,
  dashboardInfoViewOpen: false,
  publishingDashboard: false,
  selectedOrganization: null,
};

function mapStateToProps(state) {
  return {
    publishingDashboard: state.dashboardReducer.publishingDashboard,
    selectedOrganization: state.userReducer.selectedOrganization,
    isMobileDevice: state.userReducer.isMobileDevice,
  };
}

export default connect(mapStateToProps)(DashboardHeader);
